import { triggerGoal } from './GoalManager';

const fnShowContent = () => {
  //content with the data-content="fnShowContent" tag are defaultly hidden by scss checks.
  //get all trigger related items
  let triggerItems = document.querySelectorAll('[data-function="fnShowContent"]') as NodeListOf<HTMLLinkElement>;

  triggerItems.forEach((item) => {
    //set up the onclick event for the funtion trigger items
    item.onclick = () => {
      //get this items group value
      let groupValue = item.getAttribute('data-group');
      let searchParams = '[data-content="fnShowContent"][data-group="' + groupValue + '"]';
      //search for content items to display with the same group id value
      let itemsToShow = document.querySelectorAll(searchParams) as NodeListOf<HTMLLinkElement>;
      //mark these items to be visible
      for (let i = 0; i < itemsToShow.length; i++) {
        let itemToShow = itemsToShow[i];
        itemToShow.style.display = 'block';
      }

      //get all trigger items in the same group to determine if we need to disable them after click or not
      let triggerSearchParams = '[data-function="fnShowContent"][data-group="' + groupValue + '"]';
      let triggerItemsToDisable = document.querySelectorAll(triggerSearchParams) as NodeListOf<HTMLLinkElement>;

      for (let i = 0; i < triggerItemsToDisable.length; i++) {
        let triggerItem = triggerItemsToDisable[i];
        if (!triggerItem.hasAttribute('data-keepEnabled')) {
          triggerItem.setAttribute('disabled', '');
          //in case its a link and disabled isn't enough, maybe make it not clickable either
          if (triggerItem.tagName.toLowerCase() === 'a') {
            triggerItem.style.cursor = 'default';
            triggerItem.style.pointerEvents = 'none';
          }
        }
      }

      //additional check for goal
      if (item.hasAttribute('goal')) {
        triggerGoal(item.getAttribute('goal') ?? '');
      }
    };
  });
};

export const configureCDTManager = () => {
  fnShowContent();
};
